<template>
  <div v-if="product">
    <v-card>
      <v-card-title>
        {{ product.name }}
        <v-icon
          class="ml-2"
          small
          :color="
            product.blankCanvasTemplate && product.blankCanvasTemplate.published
              ? 'success'
              : 'error'
          "
        >
          wifi
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="caption">
        <v-row>
          <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ product.id }} </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Ex. Id</span>
            {{ product.externalId }}
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider />
      <v-card-text>
        <v-btn
          v-if="!product.blankCanvasTemplate"
          block
          :loading="generating"
          @click="generateBlankCanvas"
        >
          Generate Blank Canvas Template
        </v-btn>
        <template v-else>
          <v-btn
            outlined
            block
            @click="openTemplate"
          >
            View Blank Canvas Template
          </v-btn>
          <v-btn
            block
            :loading="generating"
            class="mt-2"
            @click="generateBlankCanvas"
          >
            Re-generate Blank Canvas Template
          </v-btn>
          <TemplatesEdit ref="editTemplate" />
        </template>
        <v-btn
          block
          color="mcsprimary"
          class="mt-2"
          @click="$emit('print')"
        >
          Manage Print ({{ connected(product.id).length }} of
          {{ available(product.width, product.height).length }} enabled)
        </v-btn>
        <ProductForm
          ref="form"
          class="mt-6"
          @save="saveFinished"
        />
      </v-card-text>
      <v-card-text>
        <v-btn
          color="primary"
          :loading="saving"
          block
          @click="save"
        >
          Save
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ProductForm from '@/components/products/Form';
import TemplatesEdit from '@/components/templates/Edit';
import { mapGetters } from 'vuex';
export default {
  name: 'EditProduct',
  components: { ProductForm, TemplatesEdit },
  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      generating: false
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    product: {
      get() {
        return this.$store.getters['products/edit_product'];
      },
      set(val) {
        this.$store.dispatch('products/edit', val);
      }
    },
    ...mapGetters({
      connected: 'print/connected',
      available: 'print/available'
    })
  },

  watch: {
    id(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.loadData();
      }
    }
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('products/get', this.id),
        this.$store.dispatch('guides/getList', this.id),
        this.$store.dispatch('outputs/getList', this.id),
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('lookup/getProducts'),
        this.$store.dispatch('print/getAllProducts'),
        this.$store.dispatch('print/getLookups'),
        this.$store.dispatch('products/getResourceImages', this.id)
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async save() {
      this.saving = true;
      this.$refs.form.save();
    },

    saveFinished() {
      this.saving = false;
      this.$root.$snackbarSuccess('Core Product saved');
    },

    generateBlankCanvas() {
      this.generating = true;
      this.$store
        .dispatch('products/generateBlankCanvas', this.product.id)
        .then(() => {
          this.$root.$snackbarSuccess('Blank canvas generated');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.generating = false;
        });
    },
    openTemplate() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_TEMPLATE_SHOW, {
        id: this.product.blankCanvasTemplate.id
      });
    }
  }
};
</script>
